const ApplicationsModule = () => import('@/modules/ApplicationsModule')

export default [
	{
		component: ApplicationsModule,
		name: 'applications',
		path: 'applications'
	}
]
